import { render } from "./SlideView.vue?vue&type=template&id=60f47fd9&scoped=true"
import script from "./SlideView.vue?vue&type=script&lang=js"
export * from "./SlideView.vue?vue&type=script&lang=js"

import "./SlideView.vue?vue&type=style&index=0&id=60f47fd9&lang=css"
import "./SlideView.vue?vue&type=style&index=1&id=60f47fd9&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f47fd9"]])

export default __exports__